import * as firebase from "firebase";

import "firebase/firestore";
import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCbHswcjpL9kmoXriWr9Xf-rTDcM9t9Tzg",
  authDomain: "signal-clone-bae47.firebaseapp.com",
  projectId: "signal-clone-bae47",
  storageBucket: "signal-clone-bae47.appspot.com",
  messagingSenderId: "827800149725",
  appId: "1:827800149725:web:9be7c81cf7107149c20534",
};

let app;

if (firebase.apps.length === 0) {
  app = firebase.initializeApp(firebaseConfig);
} else {
  app = firebase.app();
}

const db = app.firestore();
const auth = firebase.auth();

export { db, auth };
